import React from "react";
import {Async} from "react-select";
import AsyncPaginate from 'react-select-async-paginate';
import BaseComponent from "../../baseComponent.js";
import DatasetService from "../../../core/services/datasetService";
import styles from "./styles.scss";
import DashboardService from "../../../core/services/dashboardService";
import InternalEvent from "../../../core/constants/internalEvent";

const pageSize = 10;

/**
 * Dataset control widget allows user to search datasets and select one of searched datasets.
 * When user select a dataset, it updates two dashboard variables [variableName]DatasetId and [variableName]DatasetName.
 * If [variableName]SearchText variable has value, it will automatically search datasets and select the first available dataset.
 */
export class DatasetControl extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    const variables = this.props.metaData.variables.map(v => {
      return DashboardService.getCurrentDashboardVariableById(v.id);
    });

    const datasetName = variables.find(v => v.name === this.props.metaData.variableName + "DatasetName").value;
    const datasetId = variables.find(v => v.name === this.props.metaData.variableName + "DatasetId").value;
    return {
      variables,
      selectedOption: {
        label: datasetName,
        value: datasetId
      }
    }
  }

  componentDidMount() {
    this.findOneDataset();
  }

  /***
   * Finds datasets using search text variable and selects the first available dataset
   */
  findOneDataset() {
    const datasetIdVariable = this.state.variables.find(v => v.name === this.props.metaData.variableName + "DatasetId");
    const datasetSearchVariable = this.state.variables.find(v => v.name === this.props.metaData.variableName + "SearchText");
    const datasetId = datasetIdVariable.value ? datasetIdVariable.value.trim() : null;
    const searchText =  datasetSearchVariable.value ? datasetSearchVariable.value.trim() : null;

    // search text has higher priority than dataset id.
    if (searchText && searchText.length) {
      DatasetService.getDataSetsByName(searchText)
        .then(datasets => {
          const selectedOption = {
            label: datasets.length ? datasets[0].name : "",
            value: datasets.length ? datasets[0].persistenceId : ""
          };
          this.setState({selectedOption});
          this.handleChange(selectedOption);
        });
    } else if (datasetId) {
      DatasetService.getDataSetById(datasetId)
        .then(dataset => {
          if (dataset) {
            const selectedOption = {
              label: dataset.name,
              value: dataset.persistenceId
            };
            this.setState({selectedOption});
            this.handleChange(selectedOption);
          }
        });
    }
  }

  handleChange(selectedOption) {
    this.setState({selectedOption});
    const datasetNameVariable = this.state.variables.find(v => v.name === this.props.metaData.variableName + "DatasetName");
    const datasetIdVariable = this.state.variables.find(v => v.name === this.props.metaData.variableName + "DatasetId");
    datasetNameVariable.value = selectedOption.label;
    datasetIdVariable.value = selectedOption.value;
    DashboardService.updateDashboardVariables([datasetNameVariable, datasetIdVariable]);
    this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, [datasetNameVariable, datasetIdVariable])
  }

  searchDatasets(input, loadedOptions) {
    // makes AsyncPaginate cache empty
    this.setState({cacheUniq: input});

    const searchText = input.trim();
    if (searchText.length) {
      return new Promise(resolve => {
        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(() => {
          const pageNumber = Math.round(loadedOptions.length / pageSize) + 1;
          DatasetService.getDataSetsByName(input, {pageSize, pageNumber})
            .then(datasets => {
              const options = datasets
                .filter(d => d.name.toLowerCase().indexOf(input.toLowerCase()) > -1)    // for user search, only match on name field
                .map(d => {
                  return {
                    value: d.persistenceId,
                    label: d.name,
                    description: d.description
                  }
                });
              resolve({options, hasMore: datasets.length === pageSize});
            })
        }, 600);
      });
    } else {
      return Promise.resolve({options: [], hasMore: false});
    }
  }

  render() {
    return (
      <div className={styles.selectionControl}>
        {this.props.showLabel ? <div className={styles.floatLabel}>{this.props.metaData.title}</div> : null}
        <AsyncPaginate
          name="variable-type"
          value={this.state.selectedOption}
          loadOptions={this.searchDatasets}
          onChange={this.handleChange}
          cacheUniq={this.state.cacheUniq}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/datasetControl.jsx